/* ========================================================================
 * Apricot's Custom Styles
 * ======================================================================== */

// SCSS
import '../scss/includes/apricot-custom.scss';

// javaScript
export default {};
